import i18n from "../../../i18n";import { Trans } from "react-i18next";import { Check, Globe, MapPin, Pencil, Trash2 } from "lucide-react";
import { cn } from "../../../lib/utils";
import { Button } from "../../../components/ui/button";
import { formatDate } from "../../attendance-management/utils/dateUtils";

function TypePill({ type }) {
  const isHoliday = type === "Public Holiday";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap border",
        isHoliday ?
        "bg-indigo-50 text-indigo-700 border-indigo-200" :
        "bg-rose-50 text-rose-700 border-rose-200"
      )}>
      
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full shrink-0",
          isHoliday ? "bg-indigo-500" : "bg-rose-500"
        )} />
      
      {type}
    </span>);

}

function VisibilityCell({ visibility, scopeValues }) {
  const isGlobal = visibility === "Global";
  let scopeText = visibility;

  if (!isGlobal && scopeValues?.length > 0) {
    scopeText =
    scopeValues.length > 2 ?
    `${scopeValues.slice(0, 2).join(", ")} +${scopeValues.length - 2} more` :
    scopeValues.join(", ");
  }

  return (
    <span
      title={scopeValues?.join(", ")}
      className="inline-flex items-center gap-1.5 text-[var(--color-text-secondary)] text-sm">
      
      {isGlobal ?
      <>
          <Globe className="h-3.5 w-3.5 shrink-0" /> <Trans i18nKey="holidays.global" />
        </> :

      <>
          <MapPin className="h-3.5 w-3.5 shrink-0" /> {scopeText}
        </>
      }
    </span>);

}

export function HolidayEventRow({ event, openEditPanel, setDeletingEvent }) {
  return (
    <tr className="hover:bg-[var(--color-workspace)]/20 transition-colors">
      <td className="px-4 py-3.5 align-top">
        <div className="font-semibold text-foreground text-sm">{event.title}</div>
        <div className="text-xs text-muted-foreground mt-0.5 font-normal">
          {event.description || "No description provided."}
        </div>
      </td>
      <td className="px-4 py-3.5 whitespace-nowrap">
        <TypePill type={event.type} />
      </td>
      <td className="px-4 py-3.5 whitespace-nowrap text-sm text-foreground">
        <div>{formatDate(event.start)}</div>
        <div className="text-xs text-[var(--color-text-secondary)] mt-1">
          {event.startDay}
        </div>
      </td>
      <td className="px-4 py-3.5 whitespace-nowrap text-sm text-foreground">
        <div>{formatDate(event.end)}</div>
        <div className="text-xs text-[var(--color-text-secondary)] mt-1">
          {event.endDay}
        </div>
      </td>
      <td className="px-4 py-3.5 whitespace-nowrap text-sm">
        {event.allDay ?
        <Check className="h-4 w-4 text-[var(--color-success)]" /> :

        <span className="text-xs text-[var(--color-text-secondary)]">
            {event.startTime} - {event.endTime}
          </span>
        }
      </td>
      <td className="px-4 py-3.5">
        <VisibilityCell visibility={event.visibility} scopeValues={event.scopeValues} />
      </td>
      <td className="px-4 py-3.5 whitespace-nowrap">
        <div className="flex items-center gap-1.5">
          <Button
            type="button"
            variant="outline"
            onClick={() => openEditPanel(event)}
            className="h-8 w-8 p-0 rounded-lg border-[var(--color-text-border)]"
            aria-label={i18n.t("formActions.editEvent")}>
            
            <Pencil className="h-3.5 w-3.5 text-[var(--color-primary)]" />
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => setDeletingEvent(event)}
            className="h-8 w-8 p-0 rounded-lg border-[var(--color-text-border)]"
            aria-label={i18n.t("formActions.deleteEvent")}>
            
            <Trash2 className="h-3.5 w-3.5 text-[var(--color-error)]" />
          </Button>
        </div>
      </td>
    </tr>);

}
